// HEIC/HEIF → JPEG на клиенте. Гарантия конвертации — на сервере.
const HEIC_EXT = /\.(heic|heif)$/i;
const HEIC_CT = /image\/(heic|heif)/i;

export function isHeic(file) {
    if (!file) return false;
    return HEIC_EXT.test(file.name || '') || HEIC_CT.test(file.type || '');
}

export async function heicToJpeg(file) {
    if (!isHeic(file) || file.size > 32 * 1024 ** 2) return file;
    try {
        const heic2any = (await import('heic2any')).default;
        const blob = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 });
        const out = Array.isArray(blob) ? blob[0] : blob;
        const name = (file.name || 'photo').replace(HEIC_EXT, '') + '.jpg';
        return new File([out], name, { type: 'image/jpeg', lastModified: Date.now() });
    } catch (e) {
        console.warn('HEIC→JPEG (клиент) не удалось — отправим как есть, сконвертит сервер', e);
        return file; // мягкая деградация
    }
}

export async function heicToJpegMany(fileList) {
    // Decode one photo at a time; opening a large album must not exhaust browser memory.
    const result = [];
    for (const file of Array.from(fileList || [])) result.push(await heicToJpeg(file));
    return result;
}